export const addZeroToNumber = (value: number) => {
  return value < 10 ? `0${value}` : value;
};

export const convertSeconds = (value: number, customForTimeline?: boolean, wholeDuration?: boolean) => {
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const seconds = Math.floor((value % 3600) % 60);

  if (wholeDuration) {
    return `${addZeroToNumber(hours) + ':'}${addZeroToNumber(minutes)}:${addZeroToNumber(seconds)}`;
  }

  if (customForTimeline) {
    return `${hours ? addZeroToNumber(hours) + ':' : ''}${addZeroToNumber(minutes)}:${addZeroToNumber(seconds)}`;
  }

  return `${addZeroToNumber(hours)}:${addZeroToNumber(minutes)}:${addZeroToNumber(seconds)}`;
};

export const getSelectedPlaybackClip = <T extends { id: string; time_start: number; time_end: number }>(
  clips: T[], seconds: number, activeId?: string,
): T | undefined => {
  if (clips.length < 2) return undefined;
  const ordered = clips.slice().sort((a, b) => a.time_start - b.time_start);
  const contains = (clip: T) => seconds >= clip.time_start && seconds < clip.time_end;
  return ordered.find((clip) => clip.id === activeId && contains(clip)) || ordered.find(contains) ||
    ordered.find((clip) => clip.time_start > seconds) || ordered[0];
};
